import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Toaster } from '@/components/ui/sonner'
import { NavigationProgress } from '@/components/navigation-progress'
import GeneralError from '@/features/errors/general-error'
import NotFoundError from '@/features/errors/not-found-error'
import { UseAuthReturn } from '@clerk/types'
import AuthChecker from '@/components/auth-checker'

interface RouteContext {
  queryClient: QueryClient,
  auth?: UseAuthReturn
}

export const Route = createRootRouteWithContext<RouteContext>()({
  component: () => {
    return (
      <AuthChecker>
        <NavigationProgress />
        <Outlet />
        <Toaster />
        {import.meta.env.MODE === 'development' && (
          <>
            <ReactQueryDevtools buttonPosition='bottom-left' />
            <TanStackRouterDevtools position='bottom-right' />
          </>
        )}
      </AuthChecker>
    )
  },
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
})
